import gql from 'graphql-tag';

/**
 * Mutation to submit a response for an inspection item.
 * Appends a RESPONSE_ADDED event to the inspection instance.
 */
export const submitInspectionResponseMutation = gql`
  mutation submitInspectionResponse($input: SubmitInspectionResponseInput!) {
    submitInspectionResponse(input: $input) {
      success
      newVersion
    }
  }
`;
